// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createUpdateMachineStatusHistory} from '../../shared/repositories';

export const createMachineStatusHistoryReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const updateMachineStatusHistoryState = getState().reports.updateMachineStatusHistory;

        const reportCriteria = {
            ...updateMachineStatusHistoryState.criteria
        };

        try {

            const data = await createUpdateMachineStatusHistory(reportCriteria);

            dispatch({
                data,
                type: actions.CREATE_UPDATE_MACHINE_STATUS_HISTORY_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult: data.length < 1,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/action-creators/create-report.js